import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Mumbaitotrimbkeshwarcab() {



  const cardData = {
    keyword: " Mumbai to Trimbakeshwar Cab",


"headingDescription": "Royal Route Cab offers reliable Mumbai to Trimbakeshwar cab service, providing safe, comfortable, and affordable pilgrimage travel for families, groups, and devotees. Trimbakeshwar is one of the most important Jyotirlinga temples of Lord Shiva, located near Nashik in Maharashtra, approximately 170 km from Mumbai. Our professional drivers ensure a smooth, punctual, and stress-free journey through scenic highways and ghat sections, making your spiritual trip peaceful and comfortable. We offer flexible options including one-way drops, round trips, and customized temple darshan packages covering nearby religious sites. Our fleet includes sedans, SUVs, Innova, Ertiga, Innova Crysta, and Tempo Travellers suitable for all group sizes. With transparent pricing, 24/7 availability, and easy booking, Royal Route Cab is your trusted choice for Mumbai to Trimbakeshwar cab service.",

"topPlaces": [
  {
    "title": "Trimbakeshwar Jyotirlinga Temple",
    "description": "Trimbakeshwar Jyotirlinga Temple is one of the twelve sacred Jyotirlingas of Lord Shiva and holds immense spiritual importance in Hinduism. Located at the source of the Godavari River, the temple is known for its unique Shiva Linga representing Brahma, Vishnu, and Mahesh. Devotees from across India visit this holy site for darshan, rituals, and spiritual purification, especially for Kaal Sarp Dosh and other religious remedies. It is the main attraction for pilgrims traveling from Mumbai by cab."
  },
  {
    "title": "Brahmagiri Hill",
    "description": "Brahmagiri Hill is located near Trimbakeshwar and is considered the origin point of the sacred Godavari River. It is a popular trekking and spiritual destination where devotees climb steps to seek blessings and enjoy panoramic views of the surrounding Sahyadri mountains and lush greenery."
  },
  {
    "title": "Godavari River Source",
    "description": "The source of the Godavari River is a highly sacred spot near Trimbakeshwar, believed to be spiritually purifying for devotees. Pilgrims often take holy dips here before visiting the temple, making it an important part of the pilgrimage experience from Mumbai."
  },
  {
    "title": "Anjaneri Hills",
    "description": "Anjaneri Hills, located near Trimbakeshwar, is believed to be the birthplace of Lord Hanuman. It is a popular trekking destination offering scenic views, ancient caves, and spiritual significance, making it a favorite stop for nature and devotion seekers."
  },
  {
    "title": "Nashik City",
    "description": "Nashik is the nearest major city to Trimbakeshwar and is known for its religious importance, vineyards, and cultural heritage. It serves as a key transit and accommodation hub for pilgrims traveling from Mumbai to Trimbakeshwar by cab."
  },
  {
    "title": "Panchvati",
    "description": "Panchvati is a sacred area in Nashik associated with the Ramayana, where Lord Ram, Sita, and Lakshman are believed to have stayed during exile. It is a major spiritual site featuring temples like Kalaram Mandir and Sita Gufa."
  },
  {
    "title": "Sula Vineyards",
    "description": "Sula Vineyards is one of India’s most famous wine estates located near Nashik. It offers wine tours, tastings, and scenic views of vineyards, making it a popular leisure stop for travelers combining pilgrimage with relaxation."
  },
  {
    "title": "Harihar Fort",
    "description": "Harihar Fort is a unique trekking destination near Trimbakeshwar known for its steep rock-cut steps and historical significance. It attracts adventure lovers and offers panoramic views of the Sahyadri mountain range."
  },
  {
    "title": "Gangadwar",
    "description": "Gangadwar is a sacred spot near Trimbakeshwar associated with the origin of the Godavari River. It is considered highly spiritual and is visited by devotees as part of the temple pilgrimage circuit."
  },
  {
    "title": "Saptashrungi Devi Temple",
    "description": "Saptashrungi Devi Temple is a powerful Shakti Peetha located near Nashik, dedicated to Goddess Durga. It is situated on a hill and is accessible by steps and ropeway, making it an important extension for pilgrims visiting Trimbakeshwar."
  }
],






services: [
  {
    name: "Mumbai to Trimbakeshwar Cab",
    description: "Mumbai to Trimbakeshwar cab service offers a comfortable and spiritual journey to the sacred Jyotirlinga temple near Nashik. Ideal for devotees, families, and group travel, this service ensures smooth highway and ghat road travel. Professional drivers and well-maintained vehicles enhance safety. It guarantees a peaceful and hassle-free yatra experience."
  },
  {
    name: "Mumbai to Trimbakeshwar Taxi",
    description: "Mumbai to Trimbakeshwar taxi provides private and convenient transportation for pilgrimage travel. This service includes door-to-door pickup and flexible schedules. Suitable for families and devotees. It ensures a smooth and reliable journey."
  },
  {
    name: "Mumbai to Trimbakeshwar Cab Service",
    description: "Mumbai to Trimbakeshwar cab service offers professional travel solutions with multiple vehicle options. This service is ideal for religious trips and long-distance travel. Clean vehicles and trained drivers ensure comfort. It ensures a safe and pleasant journey."
  },
  {
    name: "Mumbai to Trimbakeshwar Taxi Service",
    description: "Mumbai to Trimbakeshwar taxi service ensures dependable transportation with comfortable vehicles and experienced chauffeurs. This service is ideal for temple visits and family travel. Flexible booking options enhance convenience. It guarantees a smooth journey."
  },
  {
    name: "Cab from Mumbai to Trimbakeshwar",
    description: "Cab from Mumbai to Trimbakeshwar offers a convenient way to travel between cities with complete comfort. This service is ideal for devotees preferring road travel. Professional drivers ensure safe journeys. It ensures a relaxed experience."
  },
  {
    name: "Taxi from Mumbai to Trimbakeshwar",
    description: "Taxi from Mumbai to Trimbakeshwar provides reliable long-distance travel for individuals and groups. This service ensures smooth highway journeys with experienced drivers. Comfortable seating enhances the experience. It guarantees a dependable ride."
  },
  {
    name: "Mumbai to Trimbakeshwar Cab Booking",
    description: "Mumbai to Trimbakeshwar cab booking allows customers to reserve their ride easily with flexible options. Travelers can choose vehicle type, pickup location, and timing. Instant confirmation ensures availability. It simplifies travel planning."
  },
  {
    name: "Mumbai to Trimbakeshwar Taxi Booking Online",
    description: "Mumbai to Trimbakeshwar taxi booking online provides a quick and convenient way to plan your pilgrimage. Customers can compare vehicles and pricing easily. Secure payment and instant confirmation enhance convenience. It ensures hassle-free booking."
  },
  {
    name: "Mumbai to Trimbakeshwar Cab Price",
    description: "Mumbai to Trimbakeshwar cab price varies based on vehicle type, distance, and trip duration. Transparent pricing ensures no hidden charges. Customers can choose from budget and premium options. It helps in planning travel expenses efficiently."
  },
  {
    name: "Mumbai to Trimbakeshwar Taxi Fare",
    description: "Mumbai to Trimbakeshwar taxi fare is designed to be affordable and transparent. Fare depends on route and vehicle selection. Customers receive clear pricing details before booking. It ensures cost-effective travel."
  },
  {
    name: "Mumbai to Trimbakeshwar One Way Cab",
    description: "Mumbai to Trimbakeshwar one way cab offers cost-effective travel without return charges. This service is ideal for single-side journeys. Flexible pickup options enhance convenience. It ensures smooth and economical travel."
  },
  {
    name: "Mumbai to Trimbakeshwar Round Trip Taxi",
    description: "Mumbai to Trimbakeshwar round trip taxi provides complete travel solutions including return journeys. This service is ideal for same-day or multi-day temple visits. Flexible schedules enhance convenience. It ensures a hassle-free experience."
  },
  {
    name: "Mumbai to Trimbakeshwar Innova Cab",
    description: "Mumbai to Trimbakeshwar Innova cab is perfect for families and groups seeking spacious and comfortable travel. Premium seating and smooth performance enhance long journeys. It ensures a comfortable pilgrimage experience."
  },
  {
    name: "Mumbai to Trimbakeshwar Ertiga Cab",
    description: "Mumbai to Trimbakeshwar Ertiga cab offers affordable and spacious travel for small groups and families. Comfortable seating and good mileage make it ideal for long-distance journeys. It ensures a pleasant trip."
  },
  {
    name: "Mumbai to Trimbakeshwar Sedan Cab",
    description: "Mumbai to Trimbakeshwar sedan cab is ideal for individuals and small families seeking economical travel. Sedans offer smooth rides and comfort for long journeys. Professional drivers ensure safety. It ensures a relaxed journey."
  },
  {
    name: "Mumbai to Trimbakeshwar SUV Taxi",
    description: "Mumbai to Trimbakeshwar SUV taxi provides spacious and comfortable travel for groups. SUVs offer better performance and extra luggage space. Suitable for long-distance journeys. It ensures a comfortable travel experience."
  }
],

tableData: [
  ["Mumbai to Trimbakeshwar Cab", "Mumbai to Trimbakeshwar Taxi"],
  ["Mumbai to Trimbakeshwar Cab Service", "Mumbai to Trimbakeshwar Taxi Service"],
  ["Cab from Mumbai to Trimbakeshwar", "Taxi from Mumbai to Trimbakeshwar"],
  ["Mumbai to Trimbakeshwar Cab Booking", "Mumbai to Trimbakeshwar Taxi Booking Online"],
  ["Mumbai to Trimbakeshwar Cab Price", "Mumbai to Trimbakeshwar Taxi Fare"],
  ["Mumbai to Trimbakeshwar One Way Cab", "Mumbai to Trimbakeshwar Round Trip Taxi"],
  ["Mumbai to Trimbakeshwar Innova Cab", "Mumbai to Trimbakeshwar Ertiga Cab"],
  ["Mumbai to Trimbakeshwar Sedan Cab", "Mumbai to Trimbakeshwar SUV Taxi"]
],


whychoose: [
  {
    WhyChooseheading: "Comfortable Mumbai to Trimbakeshwar Travel",
    WhyChoosedescription: "Royal Route Cabs offers a smooth and comfortable Mumbai to Trimbakeshwar cab service, ideal for religious trips and family travel."
  },
  {
    WhyChooseheading: "Experienced Temple Route Drivers",
    WhyChoosedescription: "Our drivers are well-trained and experienced in ghat and temple routes, ensuring safe driving and smooth travel."
  },
  {
    WhyChooseheading: "Perfect for Jyotirlinga Darshan",
    WhyChoosedescription: "Plan your Trimbakeshwar Jyotirlinga darshan conveniently with our reliable cab services for pilgrims and families."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear and upfront pricing including tolls, driver allowance, and all travel costs with no hidden charges."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Choose from one-way cab service, round-trip bookings, or same-day return options for Trimbakeshwar trips."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Mumbai to Trimbakeshwar cab service operates 24/7, allowing flexible departure anytime as per your schedule."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "We offer sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, Tempo Travellers, and mini buses for group travel."
  },
  {
    WhyChooseheading: "Trusted Religious Travel Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by devotees for Mumbai to Trimbakeshwar cab bookings due to reliable service and professional drivers."
  }
]

};

const faqData = [
  { question: "Do you provide Mumbai to Trimbakeshwar cab service?", answer: "Yes, Royal Route Cabs offers reliable cab services from Mumbai to Trimbakeshwar for one-way and round trips." },
  { question: "What is the distance between Mumbai and Trimbakeshwar?", answer: "The distance is approximately 180 to 200 km and takes around 4 to 5 hours depending on route and traffic." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Mumbai to Trimbakeshwar cab service operates 24/7." },
  { question: "Which vehicles are available for this route?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, Tempo Travellers, and mini buses." },
  { question: "Can I book a one-way cab?", answer: "Yes, we provide both one-way and round-trip cab services." },
  { question: "Is this suitable for same-day return?", answer: "Yes, same-day return trips are available for Trimbakeshwar darshan." },
  { question: "Do you provide Jyotirlinga darshan packages?", answer: "Yes, we provide customized darshan packages for Trimbakeshwar and nearby temples." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended especially during weekends and religious occasions." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we provide pickup from home, hotel, and office anywhere in Mumbai." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sandeep Joshi",
    feedback: "The Mumbai to Trimbakeshwar cab service with Royal Route Cabs was very smooth and peaceful. The driver was experienced and ensured a comfortable spiritual journey.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita Deshmukh",
    feedback: "Excellent experience traveling from Mumbai to Trimbakeshwar. The cab was clean, the ride was calm, and the overall trip felt safe and well-managed.",
    rating: 5
  }
];










  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Trimbakeshwar Cab",
  "image": "https://www.royalroutecabs.com/assets/images/mumbai-to-trimbakeshwar-cab.jpg", // replace if needed
  "description": "Book Mumbai to Trimbakeshwar cab service with Royal Route Cabs for safe, reliable, and comfortable pilgrimage travel. Available for one-way and round-trip journeys with sedan, SUV, Innova, and Ertiga vehicles. 24x7 outstation taxi service from Mumbai.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "5999", // approx starting package (adjust if needed)
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/mumbai-to-trimbakeshwar-cab"
  }
};





  return (
    <div>

<Helmet>
  <title>Mumbai to Trimbakeshwar Cab | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Mumbai to Trimbakeshwar cab with Royal Route Cabs. Safe and affordable pilgrimage taxi service with sedan, SUV, Innova & Ertiga cars. 24x7 reliable outstation travel."
  />

  <meta
    name="keywords"
    content="mumbai to trimbakeshwar cab, mumbai to trimbakeshwar taxi, mumbai to trimbakeshwar cab service, mumbai to trimbakeshwar taxi service, cab from mumbai to trimbakeshwar, taxi from mumbai to trimbakeshwar, mumbai to trimbakeshwar cab booking, mumbai to trimbakeshwar taxi booking online, mumbai to trimbakeshwar cab price, mumbai to trimbakeshwar taxi fare, mumbai to trimbakeshwar one way cab, mumbai to trimbakeshwar round trip taxi, mumbai to trimbakeshwar innova cab, mumbai to trimbakeshwar ertiga cab, mumbai to trimbakeshwar sedan cab, mumbai to trimbakeshwar suv taxi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/58.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitotrimbkeshwarcab;